import { render, staticRenderFns } from "./group_product.vue?vue&type=template&id=2c3e0714&"
import script from "./group_product.vue?vue&type=script&lang=js&"
export * from "./group_product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports